import {
  Row,
  Col,
  Card,
  Table,
  Typography,
  notification,
  Modal,
  Switch,
} from "antd";
import { Input, Button } from "antd";
import { SearchOutlined, ExclamationCircleOutlined } from "@ant-design/icons";


// Images
import React, { useEffect, useState } from "react";
import { getBookingById, getBookings, getBookingsRental, getBookingsTour, getDashStats, deleteBookings, deleteRentalBookings, deleteTourBookings } from "../api/booking.service";
import { getUserPreferences, updateUserPreferences } from "../api/user.service";
import moment from "moment";
import TimerCell from "../components/TimerCell";
import Summary from "../components/forms/Summary";
import RentalSummary from "../components/forms/RentalSummary";
import TourSummary from "../components/forms/TourSummary";
import MetricSectionIndustry from "../sections/MetricSectionIndustry";
import config from '../config';
const { Title } = Typography;

function Dashboard() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fetchedBooking, setFetchedBooking] = useState({});

  const [dashStats, setDashStats] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isHideElapsedchecked, setChecked] = useState(false);
  const [originalBookings, setOriginalBookings] = useState([]);


  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };


  // project table start
  const project = [
    {
      title: "REFERENCE NO",
      dataIndex: "referenceNo",
      width: 100,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Search Reference No"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
          </Button>
          <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) =>
        record.referenceNo
          ? record.referenceNo.toString().toLowerCase().includes(value.toLowerCase())
          : "",
      render: (text, record) => <div>{record.referenceNo}</div>,
    },
    {
      title: "TIMER (d h m s)",
      key: "timer",
      width: 100,
      render: (text, record) => {
        return (
          <>
            {(record?.referenceNo?.includes('SPAT') && record?.dateTime) && <TimerCell dateTime={record?.dateTime} referenceNo={record?.referenceNo} />}
            {(record?.referenceNo?.includes('SPVR') && record?.dateRange) && <TimerCell dateTime={record?.dateRange[0]} referenceNo={record?.referenceNo} />}
          </>

        )
      },
    },
    {
      title: "ACTION",
      key: "action",
      width: 100,
      render: (text, record) => {
        return (
          <a 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open(config.API_URL + '/' + record?.latestPdf, '_blank');
            }}
            style={{ color: '#1890ff', textDecoration: 'none' }}
          >
            View latest PDF
          </a>
        );
      }
    }
  ];

  const [bookings, setBookings] = useState([]);

  const fetchBookings = async (filter = 'all') => {
    setLoading(true);
    setError(null);
    try {
      const [data, data2, data3, data4] = await Promise.all([getBookings(filter), getBookingsRental(), getBookingsTour(), getDashStats()])
      const allBookings = [...data?.data, ...data2?.data, ...data3?.data] || [];
      setBookings(allBookings);
      setOriginalBookings(allBookings);
      setDashStats(data4?.data)
      // notification.success({ message: 'Data refreshed' })
    } catch (err) {
      setError('Failed to fetch bookings.');
    } finally {
      setLoading(false);
    }
  };

  // Fetch user preferences on mount
  useEffect(() => {
    const loadPreferences = async () => {
      try {
        const response = await getUserPreferences();
        const preferences = response?.data || {};
        if (preferences.hideElapsedAllBookings !== undefined) {
          setChecked(preferences.hideElapsedAllBookings);
        }
      } catch (error) {
        console.error("Error loading preferences:", error);
      }
    };
    loadPreferences();
  }, []);

  // Save preferences when toggle changes
  const handleToggleChange = async (checked) => {
    setChecked(checked);
    try {
      await updateUserPreferences({ hideElapsedAllBookings: checked });
    } catch (error) {
      console.error("Error saving preferences:", error);
      notification.error({
        message: "Failed to save preference",
      });
      // Revert on error
      setChecked(!checked);
    }
  };

  // Filter bookings based on toggle state
  useEffect(() => {
    if (isHideElapsedchecked) {
      const filteredBookings = originalBookings.filter((booking) => {
        // Check booking type and get appropriate date field
        let bookingDateTime;
        if (booking.referenceNo?.startsWith('SPAT') && booking.dateTime) {
          bookingDateTime = moment.utc(booking.dateTime).tz("Asia/Karachi");
        } else if (booking.referenceNo?.startsWith('SPVR') && booking.dateRange?.[0]) {
          bookingDateTime = moment.utc(booking.dateRange[0]).tz("Asia/Karachi");
        } else if (booking.referenceNo?.startsWith('SPTP') && booking.dateRange?.[0]) {
          bookingDateTime = moment.utc(booking.dateRange[0]).tz("Asia/Karachi");
        } else {
          return true; // Include if no date found
        }

        const nowInPKT = moment().tz("Asia/Karachi");
        return bookingDateTime.isAfter(nowInPKT);
      });
      setBookings(filteredBookings);
    } else {
      setBookings(originalBookings);
    }
  }, [isHideElapsedchecked, originalBookings]);

  useEffect(() => {
    fetchBookings();
  }, []);

  useEffect(() => {
    const ws = new WebSocket(process.env.REACT_APP_API_URL.replace('https://', 'wss://').replace('http://', 'ws://')); 

    ws.onopen = () => {
      console.log("Connected to WebSocket server");
    };

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.event === "booking-added" || data.event === "booking-status-change" || data.event === "rental-booking-added" || data.event === "tour-booking-added") {
        fetchBookings();
      }
    };

    ws.onclose = () => {
      console.log("Disconnected from WebSocket server");
    };

    // Cleanup WebSocket connection on unmount
    return () => {
      ws.close();
    };
  }, []);

  useEffect(() => {
    fetchBookings();
  }, []);

  const handleBulkDelete = async () => {
    if (selectedRowKeys.length === 0) {
      notification.warning({
        message: 'Please select at least one booking to delete'
      });
      return;
    }

    // Group selected bookings by type based on referenceNo prefix
    const airportBookings = [];
    const rentalBookings = [];
    const tourBookings = [];

    selectedRowKeys.forEach(referenceNo => {
      const booking = bookings.find(b => b.referenceNo === referenceNo);
      if (booking) {
        if (booking.referenceNo?.startsWith('SPAT')) {
          airportBookings.push(booking.id);
        } else if (booking.referenceNo?.startsWith('SPVR')) {
          rentalBookings.push(booking.id);
        } else if (booking.referenceNo?.startsWith('SPTP')) {
          tourBookings.push(booking.id);
        }
      }
    });

    const totalCount = airportBookings.length + rentalBookings.length + tourBookings.length;

    Modal.confirm({
      title: (
        <span style={{ color: '#ff4d4f', fontWeight: 'bold', fontSize: '18px' }}>
          <ExclamationCircleOutlined style={{ marginRight: 8 }} />
          Warning - Permanent Deletion
        </span>
      ),
      icon: <ExclamationCircleOutlined style={{ color: '#ff4d4f' }} />,
      content: (
        <div style={{ fontSize: '16px', marginTop: 10 }}>
          <p style={{ fontWeight: 'bold', marginBottom: 10 }}>
            Are you sure you want to permanently delete <strong style={{ color: '#ff4d4f' }}>{totalCount}</strong> booking(s)?
          </p>
          {airportBookings.length > 0 && (
            <p style={{ marginBottom: 5 }}>
              • Airport bookings: <strong>{airportBookings.length}</strong>
            </p>
          )}
          {rentalBookings.length > 0 && (
            <p style={{ marginBottom: 5 }}>
              • Rental bookings: <strong>{rentalBookings.length}</strong>
            </p>
          )}
          {tourBookings.length > 0 && (
            <p style={{ marginBottom: 5 }}>
              • Tour bookings: <strong>{tourBookings.length}</strong>
            </p>
          )}
          <p style={{ color: '#ff4d4f', marginTop: 10 }}>
            ⚠️ This action cannot be undone. All selected bookings will be permanently removed from the database.
          </p>
        </div>
      ),
      okText: "Yes, Delete Permanently",
      okType: "danger",
      cancelText: "Cancel",
      width: 500,
      onOk: async () => {
        try {
          setLoading(true);
          
          // Delete bookings by type in parallel
          const deletePromises = [];
          
          if (airportBookings.length > 0) {
            deletePromises.push(deleteBookings(airportBookings));
          }
          
          if (rentalBookings.length > 0) {
            deletePromises.push(deleteRentalBookings(rentalBookings));
          }
          
          if (tourBookings.length > 0) {
            deletePromises.push(deleteTourBookings(tourBookings));
          }

          const results = await Promise.all(deletePromises);
          
          let totalDeleted = 0;
          results.forEach(result => {
            totalDeleted += result?.data?.deletedCount || 0;
          });

          notification.success({
            message: `Successfully deleted ${totalDeleted} booking(s)`
          });
          
          setSelectedRowKeys([]);
          fetchBookings();
        } catch (error) {
          notification.error({
            message: error?.response?.data?.msg || error?.response?.data?.message || 'Failed to delete bookings'
          });
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Bulk delete cancelled");
      },
    });
  };

  return (
    <>
      {
        dashStats &&
        <MetricSectionIndustry
          className={'w-full !px-0'}
          data={[
            {
              bgColor: 'bg-[#00803e]',
              title: `${dashStats?.airport}`,
              description: 'Airport bookings',
              titleColor: 'text-white',
              descriptionColor: 'text-white'
            },
            {
              bgColor: 'bg-[#00803e]',
              title: `${dashStats?.rental}`,
              description: 'Rental bookings',
              titleColor: 'text-white',
              descriptionColor: 'text-white'
            },
            {
              bgColor: 'bg-[#00803e]',
              title: `${dashStats?.tour}`,
              description: 'Tour bookings',
              titleColor: 'text-white',
              descriptionColor: 'text-white'
            },
            {
              bgColor: 'bg-[#00803e]',
              title: `${dashStats?.live}`,
              description: 'Live bookings',
              titleColor: 'text-white',
              descriptionColor: 'text-white'
            },
          ]}
        />}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="All Bookings"
              extra={
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Switch
                      checked={isHideElapsedchecked}
                      onChange={handleToggleChange}
                    />
                    <span style={{ marginLeft: 0 }}>
                      Hide elapsed bookings
                    </span>
                  </div>
                  {selectedRowKeys.length > 0 && (
                    <Button
                      type="primary"
                      danger
                      onClick={handleBulkDelete}
                      loading={loading}
                    >
                      Delete Selected ({selectedRowKeys.length})
                    </Button>
                  )}
                </div>
              }
            >
              <div className="table-responsive">
                <Table
                  rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys,
                    onChange: setSelectedRowKeys,
                  }}
                  rowKey="referenceNo"
                  columns={project}
                  dataSource={bookings}
                  pagination={{
                    pageSize: 100
                  }}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
